import { GuardianRequestInfo } from "@/data/common/guardian-request-info";
import { PatientRequestInfo } from "@/data/common/patient-request-info";
import { UpdatePatientInfoRequestPayload } from "@/data/payload/patient/update-paitent-info-request-payload";
import { PatientRepository } from "@/domain/repository/patient-repository";
import { SATError, SATResult } from "@sadtx/sat-error";
import { CacheInvalidator } from "@/utils/cache/cache-invalidator";

export class UpdatePatientInfoUsecase {
  //MARK:- Constructor
  constructor(
    private readonly patientRepo: PatientRepository,
    private readonly patientListCache?: CacheInvalidator
  ) {}

  //MARK:- execute
  async execute(
    patientUuid: string,
    patientInfo: PatientRequestInfo,
    guardianInfo: GuardianRequestInfo
  ): Promise<SATResult<void, SATError>> {
    const payload: UpdatePatientInfoRequestPayload = {
      patientUuid,
      payload: {
        patient: patientInfo,
        guardian: guardianInfo,
      },
    };

    console.log("updatePatientInfo", payload.payload);
    const result = await this.patientRepo.updatePatientInfo(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    // 환자 목록 캐시가 변경 전 데이터를 보여주지 않도록 비움
    this.patientListCache?.invalidate();
    return SATResult.success(void 0);
  }
}
